module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAGCAYAAAAynOUQAAAA8ElEQVQoU62QIUsEURSFz3nzRpwwII5xwDTNaDG+f2CyCv4M2waT3WoQFCYJ2t+EAQ1b/A2WLaKI8BhY75ERBRXLut54Ofd83I9Yctq2Laqq2s2ybFvSFYBpCOHlt1ouyUKMcZXkgaRDkg+SzgBc1nV93zTN8LX/P2AewD6AYwBrkp6dc3eSLlJK10VRzEII8xHKvu/LlJL7y4dlWcrM/DAMeySPJK2/l5Im6RHAjZmd53neee+f2HXdxMw2PgJaBOqck6QMwBbJHUkrP+5fR7UAbiWdMsY4BbApyQAsBCP5mR+B3+xIIslxN2qekTx5A4agaqDEJiOoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persondata/personal_icon_dao.png
// module id = BbKW
// module chunks = 1